import { DefaultState } from 'store/types';

export const LOCATION_MATCHES_REQUEST = 'LOCATION_MATCHES_REQUEST';
export const LOCATION_MATCHES_SUCCESS = 'LOCATION_MATCHES_SUCCESS';
export const LOCATION_MATCHES_FAILURE = 'LOCATION_MATCHES_FAILURE';

export interface LocationMatchesRow {
  address: string;
  compatibileGuestsCount: number;
  compatibility: number;
  distance: number;
  id: string;
  isAnyReservations: boolean;
  lodgingType: string;
  maxRate: number;
  minRate: number;
  name: string;
  likesCount: number;
  notesCount: number;
  totalBookedCount: number;
  totalOccupancy: number;
  activeRoomsCount: number;
  roomsCount: number;
};

export type LocationMatchesData = LocationMatchesRow[];

export type LocationMatchesState = DefaultState & {
  contents?: LocationMatchesData;
};

interface LocationMatchesRequest {
  type: typeof LOCATION_MATCHES_REQUEST;
};

interface LocationMatchesSuccess {
  type: typeof LOCATION_MATCHES_SUCCESS,
  contents: LocationMatchesData;
}

interface LocationMatchesFailure {
  type: typeof LOCATION_MATCHES_FAILURE;
}

export type LocationMatchesActionTypes = LocationMatchesRequest | LocationMatchesSuccess | LocationMatchesFailure;